import React, { useContext, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import Toggle from 'react-toggle';
import { RobotEnvironmentContext } from '../../../contexts/general/RobotEnvironmentContext';
import { Button } from '../../general/Button';
import { BNDList } from './DisclosureUnits/SummaryDisclosure';

export const LegalSection: React.FC<{}> = () => {
    const { t } = useTranslation('pension');
    const history = useHistory();
    const [toggleValue, setToggleValue] = useState(false);
    const { environment } = useContext(RobotEnvironmentContext);

    const getLegalStatements = () => 
        environment === 'MyBND' 
            ? getLegalStatementsMyBND() 
            : getLegalStatementsMarketing();

    const getLegalStatementsMyBND = () => 
        <BNDList>
            {t('pension-legal-page-list-item-1')}
            <ListItem2MyBND />
            {t('pension-legal-page-list-item-3-mybnd')}
            {t('pension-legal-page-list-item-4-mybnd')}
        </BNDList>

    const getLegalStatementsMarketing = () =>
        <BNDList>
            {t('pension-legal-page-list-item-1')}
            {t('pension-legal-page-list-item-2-marketing')}
            {t('pension-legal-page-list-item-3-marketing')}
            {t('pension-legal-page-list-item-4-marketing')}
        </BNDList>;

    return (
        <div className="flex flex-col gap-6 w-full sm:w-2/3 md:w-1/2 xl:w-2/5 m-auto p-4 sm:p-8">
            <div>
                <span className="font-extrabold text-3xl">{t('pension-legal-page-title')}</span>
            </div>
            <div>
                <span>{t('pension-legal-page-text-part-1')}</span>
            </div>
            <div>
                <span>{t('pension-legal-page-text-part-2')}</span>
            </div>
            <div>
                {getLegalStatements()}
            </div>
            <div className="flex flex-row gap-4 items-center mt-8">
                <Toggle
                    className="mr-4"
                    icons={false}
                    checked={toggleValue}
                    onChange={(e) => setToggleValue(e.target.checked)}
                />
                <span>{t('pension-legal-page-toggle-text')}</span>
            </div>
            <div>
                <span>
                    <a className="text-bnd-green underline" href='/' target="_blank">{t('pension-legal-page-toggle-disclaimer-link-text')}</a>
                    {t('pension-legal-page-toggle-disclaimer-suffix-text')}
                </span>
            </div>
            <div>
                <Button
                    className={`w-72 sm:w-80 px-4 font-semibold ${!toggleValue && 'opacity-50'}`}
                    tint="green"
                    size="sm"
                    isDisabled={!toggleValue}
                    showWobbleArrow={true}
                    onClick={() => {
                        history.push('personal')
                    }
                }>
                    {t('pension-legal-page-button-text')}
                </Button>
            </div>
        </div>
    );
};

const ListItem2MyBND: React.FC<{}> = () => {
    const { t } = useTranslation('pension');

    return (
        <div>
            <Trans
                t={t}
                i18nKey={'pension-legal-page-list-item-2-mybnd'}
                values={{ value: 'extra'
                }}
            >
                ...
                <span className="font-bold">value</span>
                ...
            </Trans>
        </div>
    );
};